export default "__VITE_ASSET__DwC0OJGY__"